// Symbol fuer den Startbildschirm waehlen. Flaeche, die es in der
// Original-App nicht gibt, deshalb frei gestaltet.
//
// Der Hinweis auf das Einfrieren gehoert sichtbar dazu und nicht in eine
// Fussnote: wer waehlt und nichts passieren sieht, haelt es fuer kaputt.

import { useState } from "react";
import { Check } from "lucide-react";
import { APP_SYMBOLE, gewaehltesSymbol, merkeSymbol } from "../lib/appsymbole.js";
import { Karte } from "./Bausteine.js";

export function AppSymbolAuswahl() {
  const [schluessel, setSchluessel] = useState(() => gewaehltesSymbol().schluessel);

  function waehlen(neuer: string) {
    setSchluessel(neuer);
    merkeSymbol(neuer);
  }

  return (
    <Karte
      kinder={
        <>
          <h2 className="mb-1 text-base font-medium">Symbol auf dem Startbildschirm</h2>
          <p className="mb-3 text-sm text-neutral-600">
            Gilt ab der nächsten Installation. Ein Symbol, das schon auf dem Startbildschirm
            liegt, ändert sich nicht mehr: dafür die App einmal entfernen und über „Zum
            Home-Bildschirm" neu ablegen.
          </p>
          <ul className="flex flex-wrap gap-3">
            {APP_SYMBOLE.map((symbol) => {
              const aktiv = symbol.schluessel === schluessel;
              return (
                <li key={symbol.schluessel}>
                  <button
                    type="button"
                    onClick={() => waehlen(symbol.schluessel)}
                    aria-pressed={aktiv}
                    className="flex w-24 flex-col items-center gap-1"
                  >
                    <span
                      className={`relative block overflow-hidden rounded-2xl border-2 ${
                        aktiv ? "border-akzent" : "border-transparent"
                      }`}
                    >
                      <img
                        src={symbol.vorschau}
                        alt=""
                        width={72}
                        height={72}
                        className="block h-18 w-18 object-cover"
                      />
                      {aktiv && (
                        <span className="absolute bottom-1 right-1 rounded-full bg-akzent p-0.5 text-white">
                          <Check size={14} />
                        </span>
                      )}
                    </span>
                    <span className={`text-xs ${aktiv ? "font-medium text-akzent" : "text-neutral-600"}`}>
                      {symbol.name}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </>
      }
    />
  );
}
